"use client";
import React from 'react';
import { debounce } from '../utils/function.js';

const DeviceInfoContext = React.createContext({
    tablet: false,
    phone: false,
    isAppleMobile: false,
});
function DeviceInfoProvider(props) {
    const { initialInfo, children } = props;
    const [currentInfo, setCurrentInfo] = React.useState(initialInfo);
    React.useEffect(() => {
        function update() {
            const isDesktop = window.matchMedia(`(min-width: 1024px)`).matches;
            const isTablet = window.matchMedia(`(min-width: 768px)`).matches;
            const isAppleMobile = /(iPad|iPhone)/g.test(navigator.userAgent);
            const newInfo = {
                phone: !isDesktop && !isTablet,
                tablet: !isDesktop && isTablet,
                isAppleMobile,
            };
            if (newInfo.tablet !== currentInfo.tablet ||
                newInfo.phone !== currentInfo.phone ||
                newInfo.isAppleMobile !== currentInfo.isAppleMobile) {
                setCurrentInfo(newInfo);
            }
        }
        update();
        const debouncedUpdate = debounce(update, 150);
        window.addEventListener('resize', debouncedUpdate);
        return () => {
            window.removeEventListener('resize', debouncedUpdate);
        };
    }, [currentInfo]);
    return React.createElement(DeviceInfoContext.Provider, { value: currentInfo }, children);
}

export { DeviceInfoContext, DeviceInfoProvider };
//# sourceMappingURL=DeviceInfoProvider.js.map
